import { useTranslation } from "react-i18next";
import { PersonInfo, TableItemStatus, Status } from "ui";

import { PersonalOrderBadge } from "../../../../../orders/components";
import { RETURN_STATUSES_LIST } from "../../../../constants";
import { ReturnDetails } from "../../../../returns.types";

import styles from "../ReturnModal.module.scss";

export const ReturnHeader = ({
  returnDetails
}: {
  returnDetails?: ReturnDetails;
}) => {
  const { t } = useTranslation();
  const statusesList: Status[] = RETURN_STATUSES_LIST.map((orStatus) => ({
    ...orStatus
  }));

  const orderStatusIndex = statusesList.findIndex(
    (status) => status.value === returnDetails?.status
  );

  return (
    <div className={styles.returnModal_header}>
      <PersonInfo
        image={returnDetails?.reseller.image}
        personName={`${returnDetails?.reseller.firstname} ${returnDetails?.reseller.lastname}`}
        wrapperClassName={styles.returnModal_reseller}
        nameClassName={styles.returnModal_reseller_name}
        topText={t("Reseller")}
        dimensions={{ width: 32, height: 32, borderRadius: "100px" }}
      />

      <div className={styles.returnModal_statusLabel}>
        <TableItemStatus
          activeStatusIndex={orderStatusIndex}
          statusesList={statusesList}
        />

        {returnDetails?.isPersonalOrder && <PersonalOrderBadge />}
      </div>
    </div>
  );
};
